/* eslint-disable camelcase */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import moment from 'moment-timezone'
import { AppConfig } from '../../AppConfig';
import { BaseEntityPageSlixta } from '../../components/BaseEntityPageSlixta';
import { Helper } from '../helpers/Helper';
import { ApiHelper } from '../helpers/ApiHelper';
import { Controller } from '../Controller';
import { AppHelper } from '../../helpers/AppHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { CommonTheme } from '../../styles/Styles';
import { Link } from 'react-router-dom';
import { FormControl, Grid, TextField, Tooltip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TableCard from './tables/TableCard';
import { StatCard } from './StatCard';
import { CRMHelper } from '../../helpers/CRMHelper';
import { ReactDateRangeWrapper } from './DateRangeComponent/ReactDateRangeWrapper';
import { FilterHelper } from '@slx/slixta-common';
import { DateRanges } from './DateRangeComponent/DateRanges';

function generateStaffActivityReport(items) {
  if(!items || items.length === 0) {
    return {}
  }

  const reportHeaders = ['Date', 'Interaction', 'Entity', '']
  const hiddenColumns = [3]
  const textColumnIndices = [0,1,2]
  const reportHeaderTooltips = []

  const data = items.map((item) => ({
    date: item.createdTs ? Helper.formatTimestamp(item.createdTs) : '',
    type: (item.payload && item.payload.workflowTitle) ? item.payload.workflowTitle : item.subActivityType,
    entity: item.payload ? item.payload.entityName || item.payload.entityPhone : '',
    data: {
      entityId: item.entityId,
      entityType: item.entityType,
    }
  }))

  return {
    headers: reportHeaders,
    headerTooltips: reportHeaderTooltips,
    rows: data.map(item => Object.values(item)),
    textColumnIndices: textColumnIndices,
    hiddenColumnIndices: hiddenColumns,
  }
}

function formatInteractionName(str = '') {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-\s]+/g, ' ')
    .trim()
    .toUpperCase()
}

function filterStatsByInteraction(stats, subActivityTypeFilter) {
  if(!subActivityTypeFilter || !Array.isArray(stats)) {
    return stats
  }
  return stats.filter(item => {
    if(!item || !item.key) {
      return false
    }
    return item.key === subActivityTypeFilter
      || formatInteractionName(item.key) === formatInteractionName(subActivityTypeFilter)
  })
}

function getTimeFrameData(timeFrame) {
  return {
    id: timeFrame.id,
    startValue: moment(timeFrame.startDate).startOf('day').valueOf(),
    endValue: moment(timeFrame.endDate).endOf('day').valueOf()
  }
}

function processActivityStats(stats) {
  let processedStats = []

  if(stats && stats.length > 0) {
    const formattedStats =  []
    stats.forEach(item => {
      if(item && item.key) {
        const formattedStatsObj = {}
        formattedStatsObj.key = formatInteractionName(item.key)
        formattedStatsObj.doc_count = item.doc_count
        formattedStats.push(formattedStatsObj)
      }
    })

    const grouped = formattedStats.reduce((acc, curr) => {
      if (acc[curr.key]) {
        acc[curr.key] += curr.doc_count
      } else {
        acc[curr.key] = curr.doc_count
      }
      return acc
    }, {})

    processedStats = Object.entries(grouped).map(([key, doc_count]) => ({ key, doc_count }))
  }
  return processedStats
}

export class UserActivity2 extends BaseEntityPageSlixta {

  constructor(props) {
    super(props);
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageKey = 'user-activity'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.subOrgId = this.props.match.params.subOrgId || ''
    this.staffUserId = Controller.get().getUserId()
    this.userId = this.props.match.params.userId || this.staffUserId || ''
    this.isStaffUserDrillDown = !!this.props.match.params.userId
    this.isSelf = this.userId === this.staffUserId
    this.canViewStaffActivity = Controller.get().userMgr().isProductSU()
      || Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER')
    this.pageTitle = this.isSelf ? Helper.getString('my-activity') : Helper.getString('user-activity')
    this.staffSubOrgId = Controller.get().userMgr().getSubOrgId(this.orgId)
    this.pageDialogMode = this.props.pageDialogMode || false
    this.isLogoForMobileHidden = this.props.isLogoForMobileHidden || false
    this.isHeaderTitleHidden = this.props.isHeaderTitleHidden || false
    this.hideHeaderbar = this.props.hideHeaderbar || false
    this.limit = 100
    this.isMobileView = Helper.isMobileView()
    this.timezone = Helper.getLocalTimezone()
    this.timeFrameKey = 'this_month'
    this.timeFrame = this.props.timeFrame || getTimeFrameData({id: this.timeFrameKey, startDate: FilterHelper.getEpochFromDateId(this.timeFrameKey, 'startDate', this.timezone), endDate: FilterHelper.getEpochFromDateId(this.timeFrameKey, 'endDate', this.timezone)})
    this.orgUnitId = this.props.orgUnitId || null
    this.subActivityTypeFilter = this.props.subActivityType || null
    this.filterSummary = this.props.filterSummary || null
    this.teamsEnabled = AppHelper.isTeamsEnabled(this.orgId) && !this.staffSubOrgId
    this.teams = [
      {key: 'all', label: 'All'},
    ]
    this.team = this.teams[0]
    this.apiData = {
      orgId: this.orgId,
    }
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      ...(this.canViewStaffActivity ? [{ title: Helper.getString('staff-activity'), to: `${this.baseRoute()}/staff-interactions` }] : []),
      { title: this.isSelf ? Helper.getString('my-activity') : this.userId },
    ]
    this.toFetch = [
      { key: 'staffActivity', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-staff-activity'], queryParams: this.getStaffActivityQueryParams() },
    ]
    if (!this.isSelf) {
      this.toFetch.push({ key: 'usersORG', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-org-users2'], queryParams: { orgId: this.orgId, parentOrgId: this.orgId } })
    }
    if (this.teamsEnabled && !this.isStaffUserDrillDown) {
      this.toFetch.push({ key: 'suborgs', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-sub-orgs'], queryParams: { orgId: this.orgId, parentOrgId: this.orgId } })
    }
    this.cellWidths = {}

    this.tableHeadersMap = {}
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.headerActions = [
      {
        label: 'Refresh',
        tooltip: 'Refresh',
        icon: 'refresh',
        type: 'icon-label',
        onClick: () => this.fetchItems(),
      }
    ]
    this.noAdd = true
  }

  getStaffActivityQueryParams(overrides = {}) {
    const timeFrame = overrides.timeFrame || this.timeFrame
    const orgUnitId = overrides.orgUnitId !== undefined ? overrides.orgUnitId : this.orgUnitId
    const subActivityTypeFilter = overrides.subActivityTypeFilter !== undefined
      ? overrides.subActivityTypeFilter
      : this.subActivityTypeFilter
    const queryParams = {
      orgId: this.orgId,
      staffUserId: this.userId,
      limit: this.limit,
      _includeStats: 'YES',
      startTs: timeFrame.startValue,
      endTs: timeFrame.endValue,
    }
    if (orgUnitId) {
      queryParams.orgUnitId = orgUnitId
    }
    if (subActivityTypeFilter) {
      queryParams.subActivityType = subActivityTypeFilter
    } else {
      queryParams['subActivityType!'] = 'UPDATE'
    }
    return queryParams
  }

  updateStaffActivityFetch(overrides = {}) {
    const staffActivityFetch = this.toFetch.find(f => f.key === 'staffActivity')
    if (staffActivityFetch) {
      staffActivityFetch.queryParams = this.getStaffActivityQueryParams(overrides)
    }
  }

  componentDidMount() {
    if (!this.isSelf && !this.canViewStaffActivity) {
      Controller.get().pushRoute('/no-permission')
      return
    }
    this.fetchItems()
  }

  onFetchSuccess(results, options) {
    const { fetchNext } = options || {}
    const staffActivityResponse = this.getResult(results, 'staffActivity') || {items: []}
    if (!fetchNext) {
      if (this.isSelf) {
        this.orgUser = Controller.get().userMgr().getAppUser()
      } else {
        this.usersORG = (this.getResult(results, 'usersORG') || {}).items || []
        this.orgUser = this.usersORG.find(u => u.userId === this.userId)
      }
      this.subOrgs = this.getResult(results, 'suborgs') ? this.getResult(results, 'suborgs').items : (this.subOrgs || [])
      this.staffActivity = staffActivityResponse.items || []
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute() },
        ...(this.canViewStaffActivity ? [{ title: Helper.getString('staff-activity'), to: `${this.baseRoute()}/staff-interactions` }] : []),
        { title: this.isSelf ? Helper.getString('my-activity') : Helper.formatName(this.orgUser) },
      ]
    } else {
      this.staffActivity = (this.staffActivity || []).concat(staffActivityResponse.items || [])
    }
    this.handleNextpage(staffActivityResponse)
    const nextState = {
      items: this.staffActivity,
      orgUser: this.orgUser || this.state.orgUser,
    }
    if (!fetchNext) {
      nextState.statsActivity = filterStatsByInteraction(staffActivityResponse.statsActivity, this.subActivityTypeFilter)
      nextState.doc_count = this.subActivityTypeFilter
        ? (nextState.statsActivity || []).reduce((sum, item) => sum + (item.doc_count || 0), 0)
        : staffActivityResponse.doc_count
      nextState.uniqueContacts = staffActivityResponse.uniqueContacts
      nextState.paymentValue = staffActivityResponse.paymentValue
      if (this.teamsEnabled) {
        const teams = [{key: 'all', label: 'All'}]
        if(this.subOrgs && this.subOrgs.length > 0) {
          for (const d of this.subOrgs) {
            teams.push({
              key: d.id || d.userId,
              label: d.title
            })
          }
        }
        nextState.teams = teams
        nextState.teamSelected = (this.state.teamSelected && teams.find(option => option.key === this.state.teamSelected.key))
          || teams.find(option => option.key === this.team.key)
          || teams[0]
      }
    }
    this.setState(nextState)
  }

  onDateRangeChange(dateRangeValues) {
    const timeFrame = getTimeFrameData(dateRangeValues)
    this.timeFrame = timeFrame
    this.updateStaffActivityFetch({ timeFrame, orgUnitId: this.orgUnitId })
    this.setState({
      timeFrame,
      nextPage: null,
      nextPageState: null,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
    }, () => {
      this.fetchItems()
    })
  }

  onTeamsAutoCompleteChange = (value) => {
    if(value && value.key) {
      this.orgUnitId = value.key === 'all' ? null : value.key
      this.updateStaffActivityFetch({ orgUnitId: this.orgUnitId })
      this.setState({
        teamSelected: value,
        nextPage: null,
        nextPageState: null,
        loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
      }, () => {
        this.fetchItems()
      })
    }
  }

  onActions = (headers,row, rowIndex) => {
    let current = null

    if(row && row[3]) {
      current = row[3]
    }
    const actions = []
    if(current && current.entityId) {
      let url = null
      let key = null
      if(current.entityType === 'CRMCONTACT') {
        const userId = current.entityId.includes('-') ? current.entityId.split('-')[1] : ''
        url = this.baseRoute() + '/crm-contacts/' + userId
        key = 'viewcontact-' + userId
      } else if(current.entityType === 'CRMACCOUNT') {
        const userId = current.entityId
        url = this.baseRoute() + '/crm-accounts/' + userId
        key = 'viewaccount-' + userId
      }

      if(url && key) {
        actions.push(
          <Link to={url} key={key}>
            <Tooltip title='View Contact' placement='top-start'>
              <span className={css(AppStyles.entityTableLinkIcon)}>
                <i className='material-icons-outlined'>person</i>
              </span>
            </Tooltip>
          </Link>
        )
      }
    }
    return actions
  }

  renderFilters() {
    const availableDateRanges = ['today', 'yesterday', 'this_week', 'this_month', 'last_7d', 'last_30d', 'last_90d', 'last_6m', 'last_12m', 'current_7d', 'current_30d', 'custom']

    if(this.state.timeFrame) {
      this.dateRangeOptions = {
        id: this.state.timeFrame.id,
        startDate: new Date(this.state.timeFrame.startValue),
        endDate: new Date(this.state.timeFrame.endValue)
      }
    } else {
      const defaultTimeframe = this.timeFrame
      this.dateRangeOptions = {
        id: defaultTimeframe.id,
        startDate: new Date(defaultTimeframe.startValue),
        endDate: new Date(defaultTimeframe.endValue)
      }
    }

    return (<div className={css(Styles.filterContainer)}>
      <div className={css(Styles.formControlContainer)}>
        <p className={css(Styles.label)}>{'Date'}</p>
        <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
          <ReactDateRangeWrapper
            onDateRangeChange={this.onDateRangeChange.bind(this)}
            initialRange={this.dateRangeOptions}
            availableDateRanges = {availableDateRanges}
            timezone={this.timezone}
            displayFieldStyle={Styles.displayFieldStyle}
          />
        </FormControl>
      </div>
      {this.teamsEnabled && <div className={css(Styles.formControlContainer)}>
        <p className={css(Styles.label)}>{'Team'}</p>
        <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
          <Autocomplete
            value={this.state.teamSelected || this.team}
            options={this.state.teams || this.teams}
            onChange={(e, val) => this.onTeamsAutoCompleteChange(val)}
            getOptionLabel={(option) => option.label || option.text}
            getOptionSelected={(option, value) => option.key === value.key}
            disableClearable
            forcePopupIcon={(this.state.teams || this.teams).length > 1}
            popupIcon={(this.state.teams || this.teams).length > 1 ? undefined : null}
            open={(this.state.teams || this.teams).length > 1 ? undefined : false}
            renderInput={params =>
              <TextField
                {...params}
                variant={'standard'}
                className={css(Styles.formControlFilters)}
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                  readOnly: true,
                  classes: {
                    root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                    input: css(Styles.formInputStyle, Styles.textInput),
                  },
                }} />}
          />
        </FormControl>
      </div>}
    </div>)
  }

  renderFilterSummary() {
    if(!this.filterSummary) {
      return null
    }
    const summaryItems = [
      { label: 'Date', value: this.filterSummary.date },
      { label: 'Team', value: this.filterSummary.team },
      { label: 'Interaction', value: this.filterSummary.interaction },
    ].filter(item => item.value)

    if(summaryItems.length === 0) {
      return null
    }

    return (
      <div className={css(Styles.filterSummaryContainer)}>
        {summaryItems.map(item => (
          <div key={item.label} className={css(Styles.filterSummaryItem)}>
            <span className={css(Styles.filterSummaryLabel)}>{item.label}:</span>
            <span className={css(Styles.filterSummaryValue)}>{item.value}</span>
          </div>
        ))}
      </div>
    )
  }

  renderAggregatedStats() {
    if(Array.isArray(this.state.statsActivity) && this.state.statsActivity.length > 0) {
      let cardsData = []
      cardsData.push({
        key: 'total_interactions',
        text: this.state.doc_count || 0,
        subText: 'TOTAL INTERACTIONS',
        cardIndex: 1,
        cardId: 'total_interactions',
        padding: 'small'
      })

      cardsData.push({
        key: 'unique_contacts',
        text: this.state.uniqueContacts || 0,
        subText: 'UNIQUE CONTACTS',
        cardIndex: 2,
        cardId: 'unique_contacts',
        padding: 'small'
      })

      const statsActivity = processActivityStats(this.state.statsActivity)

      const cardIndexOffset = 3
      statsActivity.forEach((card, i) => {
        cardsData.push({
          key: card.key,
          text: card.doc_count || 0,
          subText: formatInteractionName(card.key),
          cardIndex: i + cardIndexOffset,
          cardId: card.key,
          padding: 'small'
        })
      })

      if (this.state.paymentValue) {
        cardsData.push({
          key: 'total_payment_value',
          text: this.state.paymentValue || 0,
          subText: 'TOTAL PAYMENT VALUE',
          cardIndex: cardsData.length + 1,
          cardId: 'total_payment_value',
          padding: 'small'
        })
      }

      const maxCardsPerRow = 7
      cardsData = CRMHelper.splitCardsIntoBalancedRows(cardsData, maxCardsPerRow)
      if(cardsData && cardsData.length > 0) {
        return(<div className={css(Styles.tableStatItem)}>
          {((!this.isMobileView) && cardsData && cardsData.length > 0) && (<div className={css(Styles.numericStatItemRow)}>
            {cardsData.map((row)=>(<Grid container className={css(Styles.numericStatContainerRow)}>
              {row.map((card)=>(
                <StatCard
                  xs={4}
                  sm={1}
                  key={card.key}
                  text={card.text}
                  subText={card.subText}
                  cardIndex={card.cardIndex}
                  padding={card.padding}
                  cardId={card.cardId}
                  handleCardClick={card.handleCardClick}
                  containerStyle={Styles.statsCardContainer}
                  cardStyle={Styles.statsCard}
                />))}
            </Grid>))}
          </div>)}
          {((this.isMobileView)) && cardsData && cardsData.length > 0 && (<div className={css(Styles.numericStatItemRow)}>
            {cardsData.map((row, index) => {
              const rowGroups = Array.from({ length: Math.ceil(row.length / 3) })
              return (
                <Grid key={index}>
                  {rowGroups.map((_, groupIndex) => {
                    const groupItems = row.slice(groupIndex * 3, groupIndex * 3 + 3)
                    return (
                      <Grid
                        key={groupIndex}
                        container
                        className={css(Styles.numericStatContainerRow)}
                      >
                        {groupItems.map((card) => (
                          <StatCard
                            xs={12 / groupItems.length}
                            sm={12 / groupItems.length}
                            key={card.key}
                            text={card.text}
                            subText={card.subText}
                            cardIndex={card.cardIndex}
                            padding={card.padding}
                            cardId={card.cardId}
                            handleCardClick={card.handleCardClick}
                            containerStyle={Styles.statsCardContainer}
                            cardStyle={Styles.statsCard}
                          />
                        ))}
                      </Grid>
                    )
                  })}
                </Grid>
              )
            })}
          </div>)}
        </div>)
      }
    }
    return null
  }

  renderBelowTable() {
    const report = this.state.items && generateStaffActivityReport(this.state.items)

    return(
      <div className={css(Styles.outerContainer)}>
        <div className={css(Styles.reportDashboardContainer)}>
          <div className={css(Styles.reportsContainer, Styles.reportsDataContainer)}>
            {!this.isStaffUserDrillDown && this.renderFilters()}
            {this.isStaffUserDrillDown && this.renderFilterSummary()}
            {!this.isStaffUserDrillDown && this.renderAggregatedStats()}
            <div className={css(Styles.tableStatItem)}>
              <TableCard
                item={{data: report || {},  maxRows: this.limit}}
                showMoreInTable={true}
                nextPage={this.state.nextPage}
                nextPageState={this.state.nextPageState}
                onNext={this.onNext.bind(this)}
                tableRowActions={this.onActions.bind(this)}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',

  },
  reportDashboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    maxWidth: AppTheme.viewPort,
    overflow: 'hidden',
    marginBottom: 20,
    '@media (max-width: 1024px)': {
      gap: 0,
    }
  },
  reportsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 10,
  },
  reportsDataContainer: {
    marginTop: 5,
    justifyContent: 'center',
    '@media (max-width: 1024px)': {
      maxWidth: '96vw'
    }
  },
  tableStatItem: {
    flex: 1,
    minWidth: '100%',
    height: '100%',
    '@media (max-width: 767px)': {
      width: '100%',
      alignSelf: 'center',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  infoCell: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  line1: {
    fontSize: 16,
  },
  line2: {
    fontSize: 12,
    color: 'grey'
  },
  summaryContainer: {
    wordBreak: 'break-word'
  },
  cellWidthSmall: {
    width: '10%',
  },
  cellWidthNormal: {
    width: '20%',
  },
  cellWidthWide: {
    width: '50%',
  },
  numericStatItemRow: {
    '@media (max-width: 1024px)': {
      alignSelf: 'center',
      paddingTop: '8px',
      paddingBottom: '8px',
      height: '100%',
    },
    width: '100%',
  },
  numericStatContainerRow: {
    height: '100%',
    maxHeight: '100%',
    maxWidth: AppTheme.viewPort,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2px 0px 8px 0px',
    margin: 0,
    gap: 5,
    '@media (max-width: 1024px)': {
      padding: '2px 0px',
      gap: 0
    },
  },
  statsCardContainer: {
    maxWidth: 'unset',
    flex: 1,
  },
  statsCard: {
    width: '100%'
  },
  filterContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
    '@media (max-width: 1024px)': {
      paddingTop: 5
    },
  },
  formControlContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 5,
  },
  label: {
    fontSize: 14,
    color: CommonTheme.subTextColor,
    margin: 0,
    display: 'inline-block'
  },
  formControlMainFilters: {
    width: 240,
    '@media (max-width: 1024px)': {
      width: '100%',
      alignSelf: 'center',
    },
  },
  formControlFilters: {
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden'
  },
  textInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16
  },
  autoCompleteInputRoot: {
    paddingRight: 48,
    '@media (max-width: 440px)': {
      paddingRight: 18,
    },
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  textInput: {
    padding: '4px 0px',
    '@media (max-width: 440px)': {
      fontSize: 12,
    },
  },
  displayFieldStyle: {
    '@media (max-width: 1024px)': {
      width: '100%',
    },
  },
  filterSummaryContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 16,
    padding: '4px 0 8px 0',
  },
  filterSummaryItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  filterSummaryLabel: {
    fontSize: 14,
    color: CommonTheme.subTextColor,
  },
  filterSummaryValue: {
    fontSize: 14,
    color: CommonTheme.textColor,
    fontWeight: 500,
  },
})
